import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import "./ProductGallery.css";
/* import ProductHeaderV2 from "../ProductHeaderV2"; */

const ProductGallery = ({
  productImgs,
  thumbnailBlur,
  productId,
  productLoadStartMs,
  recycled,
  compositionList,
  certifications,
  touchAreaRef,
}) => {
  const safeProductImgs = useMemo(
    () => (Array.isArray(productImgs) ? productImgs : []),
    [productImgs],
  );
  const [mainImg, setMainImg] = useState(safeProductImgs[0] || null);
  const [isMainImgLoaded, setIsMainImgLoaded] = useState(false);
  const [activePlaceholder, setActivePlaceholder] = useState(thumbnailBlur || null);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [currentImgIndex, setCurrentImgIndex] = useState(0);
  const galleryRef = useRef(null);
  const mediaRef = useRef(null);
  const mainImgRef = useRef(null);
  const placeholderRectRef = useRef(null);
  const layoutShiftScoreRef = useRef(0);
  const galleryLayoutShiftScoreRef = useRef(0);

  const handleThumbnailClick = (img, index) => {
    console.log(`[Gallery] 🖼️ Thumbnail clicado: ${img}`);
    console.log("Thumbnail:", img.substring(0, 80));
    setMainImg(img);
    setCurrentImgIndex(index);
  };

  const handleScrollBarClick = (index) => {
    setMainImg(safeProductImgs[index]);
    setCurrentImgIndex(index);
  };

useEffect(() => {
  console.group("[Gallery] productImgs alterado");

  console.log("Número de imagens:", safeProductImgs.length);

  if (safeProductImgs.length > 0) {
    console.log("Primeira imagem:");
    console.log(safeProductImgs[0]);
    console.log("Tamanho Base64:", safeProductImgs[0].length);

    setMainImg(safeProductImgs[0]);
    setIsMainImgLoaded(false);
    setCurrentImgIndex(0);
  } else {
    console.warn("Nenhuma imagem recebida.");
  }

  console.groupEnd();
}, [safeProductImgs]);

  useEffect(() => {
    if (thumbnailBlur) {
      setActivePlaceholder(thumbnailBlur);
    }
    layoutShiftScoreRef.current = 0;
    galleryLayoutShiftScoreRef.current = 0;
    placeholderRectRef.current = mediaRef.current?.getBoundingClientRect() || null;
  }, [thumbnailBlur]);

  useEffect(() => {
    if (typeof PerformanceObserver === "undefined") return;

    let observer;
    try {
      observer = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          if (!entry.hadRecentInput) {
            layoutShiftScoreRef.current += entry.value;
            const affectedGallery = entry.sources?.some((source) => {
              const node = source.node;
              return Boolean(
                node
                  && galleryRef.current
                  && (galleryRef.current === node || galleryRef.current.contains(node)),
              );
            });

            if (affectedGallery) {
              galleryLayoutShiftScoreRef.current += entry.value;
            }
          }
        });
      });
      observer.observe({ type: "layout-shift" });
    } catch (err) {
      return undefined;
    }

    return () => observer?.disconnect();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    /* const handleWheel = (event) => {
      const newIndex =
        (currentImgIndex + (event.deltaY > 0 ? 1 : -1) + productImgs.length) %
        productImgs.length;
      setMainImg(productImgs[newIndex]);
      setCurrentImgIndex(newIndex);
    }; */

    window.addEventListener("resize", handleResize);

    /* const currentGallery = galleryRef.current; */
    /* if (currentGallery) {
      currentGallery.addEventListener("wheel", handleWheel);
    } */

    return () => {
      window.removeEventListener("resize", handleResize);
      /* if (currentGallery) {
        currentGallery.removeEventListener("wheel", handleWheel);
      } */
    };
  }, [currentImgIndex, safeProductImgs]);

  const imgLoadStart = useRef(null);

useEffect(() => {
  imgLoadStart.current = performance.now();

  console.group("[Gallery] mainImg alterada");

  console.log("Existe?", !!mainImg);

  if (mainImg) {
    console.log("Prefixo:", mainImg.substring(0, 80));
    console.log("Tamanho:", mainImg.length);
  }

  console.log("isMainImgLoaded:", isMainImgLoaded);

  console.groupEnd();
}, [mainImg]);

  const thumbnails = safeProductImgs;
  const hasPlaceholder = Boolean(activePlaceholder);
  const metricKey = productId || "unknown";

  const recordFinalImageMetrics = useCallback(() => {
    setIsMainImgLoaded(true);
    const elapsed = imgLoadStart.current
      ? performance.now() - imgLoadStart.current
      : 0;
    const ttfi = productLoadStartMs
      ? performance.now() - productLoadStartMs
      : elapsed;
    const finalRect = mediaRef.current?.getBoundingClientRect();
    const placeholderRect = placeholderRectRef.current;
    const globalCls = layoutShiftScoreRef.current;
    const galleryCls = galleryLayoutShiftScoreRef.current;
    const rectDeltaPx = placeholderRect && finalRect
      ? Math.max(
          Math.abs(finalRect.top - placeholderRect.top),
          Math.abs(finalRect.left - placeholderRect.left),
          Math.abs(finalRect.width - placeholderRect.width),
          Math.abs(finalRect.height - placeholderRect.height),
        )
      : 0;

    window.__DPP_METRICS__ = {
      ...(window.__DPP_METRICS__ || {}),
      [metricKey]: {
        ...((window.__DPP_METRICS__ || {})[metricKey] || {}),
        imageLoadMs: Math.round(elapsed),
        ttfiMs: Math.round(ttfi),
        ttfi: ttfi < 1000
          ? `${Math.round(ttfi)} ms`
          : ttfi < 60000
            ? `${(ttfi / 1000).toFixed(2)} s`
            : `${(ttfi / 60000).toFixed(1)} min`,
        imageFrameShiftPx: Number(rectDeltaPx.toFixed(2)),
        galleryCls: Number(galleryCls.toFixed(4)),
        pageClsDuringImage: Number(globalCls.toFixed(4)),
        imageJumpDetected: rectDeltaPx > 1,
        galleryLayoutShiftDetected: galleryCls > 0.01,
        imageMetricsMeasuredAt: new Date().toISOString(),
      },
    };

    console.log(
      `[Gallery] ✅ Imagem CARREGADA em ${elapsed.toFixed(0)}ms — TTFI real ${(ttfi / 1000).toFixed(2)}s — shift ${rectDeltaPx.toFixed(2)}px — gallery CLS ${galleryCls.toFixed(4)} — page CLS ${globalCls.toFixed(4)}`,
    );
  }, [metricKey, productLoadStartMs]);

useEffect(() => {
  const img = mainImgRef.current;

  console.group("[Gallery] Estado do elemento IMG");

  console.log("Ref existe?", !!img);
  console.log("mainImg existe?", !!mainImg);

  if (img) {
    console.log("complete:", img.complete);
    console.log("naturalWidth:", img.naturalWidth);
    console.log("naturalHeight:", img.naturalHeight);
    console.log("currentSrc:", img.currentSrc.substring(0, 80));
  }

  console.groupEnd();

  if (!img || !mainImg) return;

  if (img.complete && img.naturalWidth > 0) {
    console.log("Imagem já estava carregada.");
    recordFinalImageMetrics();
  }
}, [mainImg, recordFinalImageMetrics]);

console.groupCollapsed("[Gallery] Render");

console.log("safeProductImgs:", safeProductImgs.length);
console.log("mainImg:", !!mainImg);
console.log("isMainImgLoaded:", isMainImgLoaded);
console.log("currentImgIndex:", currentImgIndex);

console.groupEnd();

  return (
    <div className="productgallery-container" ref={galleryRef}>
      {/* {screenWidth <= 768 && (
        <Certifications
          touchAreaRef={touchAreaRef}
          recycled={recycled}
          compositionList={compositionList}
          certifications={certifications}
        />
      )} */}
      {safeProductImgs.length >= 1 && (
        <div className="img-thumbnails">
          {thumbnails.map((img, index) => thumbnails.length > 1 ? (
            <button
              key={index}
              type="button"
              aria-label={`Imagem ${index + 1} de ${thumbnails.length}`}
              aria-pressed={index === currentImgIndex}
              className={`img-thumbnail ${index === currentImgIndex ? "active" : ""}`}
              onClick={() => handleThumbnailClick(img, index)}
            ><img src={img} alt="" aria-hidden="true" /></button>
          ) : (
            <div key={index} className="img-thumbnail active">
              <img src={img} alt="" aria-hidden="true" />
            </div>
          ))}
        </div>
      )}
      {screenWidth > 768 && safeProductImgs.length >= 1 && (
        <div className="scroll-bar">
          {safeProductImgs.map((_, index) => (
            <button
              key={index}
              type="button"
              aria-label={`Imagem ${index + 1} de ${safeProductImgs.length}`}
              aria-pressed={index === currentImgIndex}
              className={`scroll-bar-item ${
                index === currentImgIndex ? "active" : ""
              }`}
              onClick={() => handleScrollBarClick(index)}
            ></button>
          ))}
        </div>
      )}

      <div className="productgallery-media" ref={mediaRef} data-product-gallery-media>
        {hasPlaceholder && (
          <img
            src={activePlaceholder}
            alt=""
            aria-hidden="true"
            className={`productgallery-placeholder ${isMainImgLoaded ? "loaded" : ""}`}
          />
        )}
        {!hasPlaceholder && !mainImg && (
          <div className="productgallery-placeholder productgallery-placeholder-fallback" />
        )}
        {mainImg && (
          <img
            ref={mainImgRef}
            src={mainImg}
            alt="img-main-produto"
            className={`img-main-produto ${isMainImgLoaded ? "loaded" : ""}`}
            onLoad={() => {
              console.group("[Gallery] onLoad");

              console.log("Imagem carregada.");
              console.log("naturalWidth:", mainImgRef.current?.naturalWidth);
              console.log("naturalHeight:", mainImgRef.current?.naturalHeight);
              console.log("complete:", mainImgRef.current?.complete);

              console.groupEnd();

              recordFinalImageMetrics();
            }}
            onError={(e) => {
              console.group("[Gallery] onError");

              console.error("Falha ao carregar imagem.");

              console.log("Src:");
              console.log(e.currentTarget.src);

              console.log("mainImg:");
              console.log(mainImg);

              console.groupEnd();
            }}
          />
        )}
      </div>
    </div>
  );
};

export default ProductGallery;
